module.exports = __webpack_public_path__ + "img/search.0591c969.png";